import React from "react";
import { CONFIDENCE_COLORS, ALERT_COLOR } from "./mapHelpers";

/**
 * Floating bottom-right legend that explains marker colors and shows the
 * current visible point count.
 */
export function Legend({ count }) {
  const items = [
    { label: "High", color: CONFIDENCE_COLORS.HIGH },
    { label: "Medium", color: CONFIDENCE_COLORS.MEDIUM },
    { label: "Low", color: CONFIDENCE_COLORS.LOW },
    { label: "Unknown", color: CONFIDENCE_COLORS.UNKNOWN },
    { label: "License alert", color: ALERT_COLOR, ring: true },
  ];
  return (
    <div
      data-testid="map-legend"
      className="absolute bottom-4 right-4 panel p-3 bg-zinc-950 border border-zinc-700 text-xs space-y-1.5 shadow-xl ring-1 ring-zinc-900/60"
      style={{ zIndex: 1000 }}
    >
      <div className="text-[10px] uppercase tracking-wider font-mono text-zinc-500 mb-1">
        {count.toLocaleString()} dispensar{count === 1 ? "y" : "ies"} on map
      </div>
      {items.map((it) => (
        <div key={it.label} className="flex items-center gap-2 text-zinc-300">
          <span
            className="inline-block rounded-full"
            style={{
              width: it.ring ? 12 : 10,
              height: it.ring ? 12 : 10,
              background: it.color,
              border: it.ring ? "2px solid #fff2" : "1px solid #0a0a0a",
            }}
          />
          {it.label}
        </div>
      ))}
    </div>
  );
}

export default Legend;
